import { render } from "./user-chip.vue?vue&type=template&id=0937d504&ts=true"
import script from "./user-chip.vue?vue&type=script&lang=ts"
export * from "./user-chip.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__